var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "newBox" }, [
    _c("div", {
      staticClass: "close",
      class: { active: _vm.status },
      on: {
        click: function($event) {
          _vm.close()
        }
      }
    }),
    _vm._v(" "),
    _c("img", {
      staticClass: "logo",
      attrs: { src: require("../assets/common/logo.png") }
    }),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "news",
        on: {
          click: function($event) {
            _vm.to("news")
          }
        }
      },
      [
        _vm.count > 0
          ? _c("div", { staticClass: "num" }, [_vm._v(_vm._s(_vm.count))])
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4bf8730e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bf8730e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/newsTopBox.vue
// module id = null
// module chunks = 